<template>
<div v-if="valid" class="users-wrapper">
  <b-tabs vertical nav-wrapper-class="nav-vertical" class="tab-wrapper">
    <b-tab active title="Kullanıcılar">
      <users/>
    </b-tab>
    <b-tab title="Bölgeler">
      <bolgeler/>
    </b-tab>
    <b-tab title="İşletmeler">
      <isletmeler/>
    </b-tab>
    <b-tab title="Şeflikler">
      <seflikler/>
    </b-tab>
    <b-tab title="Kuleler">
      <kuleler/>
    </b-tab>
    <b-tab title="Kameralar">
      <kameralar />
    </b-tab>
  </b-tabs>
</div>
</template>

<script>
import Users from './Users'
import Bolgeler from './Bolgeler'
import Isletmeler from './Isletmeler'
import Seflikler from './Seflikler'
import Kuleler from './Kuleler'
import Kameralar from './Kameralar'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BTabs, BTab, BCardText } from 'bootstrap-vue'

export default {
  components: {
    Users,
    Bolgeler,
    Isletmeler,
    Seflikler,
    Kuleler,
    Kameralar,
    BCardText,
    BTabs,
    BTab
  },
  name: 'ManageContent',
  data () {
    return {
      valid: false
    }
  },
  methods: {
    checkQualification () {
      this.$vs.loading()
      this.$store.dispatch('getUserValidation')
        .then(result => {
          console.log('getUserValidation success', result)
          if (result.data.success) {
            this.valid = true
          } else {
            this.$router.push({name: 'home'})
          }
          this.$vs.loading.close()
        })
        .catch(e => {
          console.log('getUserValidation error', e)
          this.$vs.loading.close()
        })
    }
  },
  mounted () {
    this.checkQualification()
  }
}
</script>

<style scoped>

</style>
